import { render, staticRenderFns } from "./Coordinadores.vue?vue&type=template&id=9007f47a&scoped=true"
import script from "./Coordinadores.vue?vue&type=script&lang=js"
export * from "./Coordinadores.vue?vue&type=script&lang=js"
import style0 from "./Coordinadores.vue?vue&type=style&index=0&id=9007f47a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9007f47a",
  null
  
)

export default component.exports